import { useEffect, useState } from 'react';
import {
  fetchAllPatient,
  fetchPatientById,
  createUpdatePatient,
} from '@/services/patientService';
import { useNavigate } from 'react-router-dom';
import { changePatientAdminCounter } from '@/services/authService';

export const usePatientData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [patient, setPatient] = useState(null);
  const [paises, setPaises] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);

        const data = await fetchAllPatient();

        const mappedPaises = data.pais.map(p => ({
          codigo: p.codigo,
          codigo_de_pais: p.codigo_de_pais,
          descripcion_de_pais: p.descripcion_de_pais,
          fecha_de_registro: p.fecha_de_registro,
          hora_de_registro: p.hora_de_registro,
        }));

        const mappedDepartamentos = data.estado.map(d => ({
          codigo: d.codigo_de_provincial,
          nombre: d.descripcion_de_provincia,
          paisCodigo: d.pais_codigo,
        }));

        const mappedProvincias = data.provincia.map(p => ({
          codigo: p.codigo,
          nombre: p.descripcion_de_estado_de_pais.trim(),
          departamentoCodigo: p.Departamento_codigo,
        }));

        const mappedDistritos = data.distrito.map(d => ({
          codigo: d.codigo_de_distrito,
          nombre: d.descripcion_distrito,
          estadoCodigo: d.estado_de_pais_codigo,
        }));

        setPaises(mappedPaises);
        setDepartamentos(mappedDepartamentos);
        setProvincias(mappedProvincias);
        setDistritos(mappedDistritos);

        const storedUser = JSON.parse(localStorage.getItem('user'));
        const dni = storedUser?.dni;

        if (dni) {
          const response = await fetchPatientById(dni);

          if (response?.success) {
            setPatient({
              ...response.data,
              usuario: response.data_usuario,
            });
            console.log('Datos del paciente cargados:', response.data);
          } else {
            console.warn('Paciente no encontrado para DNI:', dni);
          }
        }
      } catch (error) {
        console.error('Error cargando datos de paciente:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  const savePatient = async patientData => {
    try {
      setIsLoading(true);

      const response = await createUpdatePatient(patientData);

      if (response?.success) {
        if (response.data && typeof response.data === 'object') {
          setPatient(response.data);
        }
        navigate('/');
        return response;
      }

      throw new Error('No se pudo guardar el paciente');
    } catch (error) {
      console.error('Error guardando paciente:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const changePatientPassword = async (numero_de_dni, newPassword) => {
    try {
      setIsLoading(true);

      const response = await changePatientAdminCounter(
        numero_de_dni,
        newPassword,
      );

      if (response === true || response === 'true' || response === 1) {
        return true;
      }

      throw new Error('No se pudo cambiar la contraseña');
    } catch (error) {
      console.error('Error cambiando contraseña del paciente:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    patient,
    paises,
    departamentos,
    provincias,
    distritos,
    savePatient,
    changePatientPassword,
  };
};
